<!-- =========================================================================================
  File Name: DeviceChecklistSidebar.vue
  Description: Checklist - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/DeviceChecklistTranslate.json"></i18n>

<template>
	<el-dialog class="custom-dialog checklist-data-sidebar" :visible.sync="isSidebarActiveLocal">
		<div slot="title">
			<div>
				<h4 class="uppercase font-bold block text-xl w-full">{{ $t("Checklist") }}</h4>
				<p class="text-base text-black font-medium">{{ data ? data.categoryName : "" }}</p>
			</div>
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<vs-table ref="table" :data="checklist" class="stack-table" :noDataText="$t('Notify.NoDataAvailable')">
					<div slot="header" class="flex flex-grow justify-end">
						<vs-button type="filled" class="w-1/2 sm:w-1/3 font-bold" @click="addNewData" v-if="mixinIsCanCreateKPI">{{ $t("Actions.AddNew") }}</vs-button>
					</div>

					<template slot-scope="{ data }">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>
									<div class="flex justify-between">
										<p class="checklist-item-name font-medium sm:truncate">{{ tr.name }}</p>
										<p class="checklist-item-name font-medium sm:truncate">{{ tr.maintain_hrs }}</p>
									</div>
								</vs-td>

								<vs-td class="whitespace-no-wrap text-right">
									<i v-if="tr.can_update" class="nucleo nucleo-edit mr-3" @click.stop="editData(tr)"></i>
									<i v-if="tr.can_delete" class="nucleo nucleo-trash-can" @click.stop="showDeleteConfirm(tr.pivot_id)"></i>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</div>
		</PerfectScrollbar>

		<popup-create-or-update-checklist-item :isPopupActive="isPopupActive" @closePopup="toggleChecklistPopup" :data="popupData" />
	</el-dialog>
</template>

<script>
import _ from "lodash";
import { kpiPermissions, getUserPermissions } from "@/mixins/mixins.js";

import PopupCreateOrUpdateChecklistItem from "./PopupCreateOrUpdateChecklistItem";

export default {
	mixins: [getUserPermissions(kpiPermissions)],
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			required: true
		}
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;
		},
		data() {
			if (_.get(this.data, "categoryId")) {
				this.getChecklist(true);
			}
		}
	},
	data() {
		return {
			popupData: {},
			isPopupActive: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			}
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		checklist() {
			return this.$store.state.deviceManagement.kpiDetails || [];
		},
		categoryId() {
			return _.get(this.data, "categoryId") || null;
		}
	},
	methods: {
		async getChecklist(isRefetch = false) {
			try {
				this.$vs.loading();
				const queryOptions = {
					kpiable_id: _.get(this.data, "categoryId"),
					kpiable_type: this.$constant.KPIV2.KPIABLE_TYPE.CATEGORY
				};
				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				await this.$store.dispatch("deviceManagement/fetchKpiDetails", queryOptions);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleChecklistPopup(val = false) {
			this.isPopupActive = val;
		},
		addNewData() {
			this.popupData = {
				categoryId: this.categoryId
			};
			this.toggleChecklistPopup(true);
		},
		editData(data) {
			this.popupData = {
				categoryId: this.categoryId,
				...data
			};
			this.toggleChecklistPopup(true);
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("deviceManagement/deleteKpiDetail", id);
				this.$store.dispatch("deviceManagement/fetchCategories", {
					limit: -1,
					fetchPolicy: "no-cache"
				});
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteChecklistItemSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	},
	components: {
		PopupCreateOrUpdateChecklistItem
	}
};
</script>

<style lang="scss">
.con-vs-dialog {
	z-index: 52015;

	.vs-dialog {
		z-index: 52015;
	}
}
</style>
